import Vue from 'vue'
import vueRouter from 'vue-router'
import article from '../pages/article/index.vue'
import acticleList from '../pages/article/list.vue'
import channelPolicy from '../pages/article/channelPolicy.vue'
import expert from '../pages/expert/expert.vue'
import detailPages from '../pages/detailPages/index.vue'
import homePage from '../pages/home/homePage.vue'
import login from '../pages/login/index.vue'
import forgetPassword from '../pages/login/forgetPassword.vue'
import register from '../pages/login/register.vue'
import inquiry from '../pages/company/inquiry.vue'
import myInquiry from '../pages/company/myInquiry.vue'
import MyInquiryInfo from '../pages/company/MyInquiryInfo'
import MyInquiryCompany from '../pages/company/MyInquiryCompany'
import companyDetail from '../pages/detailPages/companyDetail.vue'
import video from '../pages/video/index.vue'
import detailInfo from '../pages/expert/detailInfo.vue'
import videoDetail from '../pages/video/videoDetail.vue'
import school from '../pages/school/index.vue'
import managementInfo from '../pages/school/info.vue'
import enable from '../pages/enable/index.vue'
import enableInfo from '../pages/enable/info.vue'
import join from '../pages/join/index.vue'
import joinList from '../pages/join/joinList'
import train from '../pages/train/index.vue'
import trainInfo from '../pages/train/info.vue'
import recommend from '../pages/recommend/index.vue'
import application from '../pages/train/application.vue'
import search from '../pages/home/search.vue'
import courseware from '../pages/video/courseware.vue'
import listlive from '../pages/video/listlive.vue'
import personal from '../pages/personal/Information.vue'
import mySign from '../pages/personal/mySin.vue'
import cart from '../pages/personal/cart.vue'
import integral from '../pages/personal/integral.vue'
import teams from '../pages/personal/teams.vue'
import products from '../pages/personal/products.vue'
import myOrders from '../pages/personal/myOrders.vue'
import infoSelf from '../pages/personal/infoSelf.vue'
import applyAfterSales from '../pages/personal/applyAfterSales.vue'
import remark from '../pages/personal/remark.vue'
import checkoutQuick from '../pages/personal/checkoutQuick.vue'
import myUserMoney from '../pages/personal/myUserMoney.vue'
import MyBooking from '../pages/personal/MyBooking.vue'
import MyBookingInfo from '../pages/personal/MyBookingInfo.vue'
import uconfig from '../pages/personal/uconfig.vue'
import addressInfo from '../pages/personal/address.vue'
import addAddress from '../pages/personal/addAddress.vue'
import addressAddInvoice from '../pages/personal/addressAddInvoice.vue'
import addressInvoice from '../pages/personal/addressInvoice.vue'
import uconfigAddressInfo from '../pages/personal/uconfig/address.vue'
import uconfigAdd from '../pages/personal/uconfig/addAddress.vue'
import uconfigInvoice from '../pages/personal/uconfig/invoiceAddress.vue'
import invoiceAddAddress from '../pages/personal/uconfig/invoiceAddAddress.vue'
import myFav from '../pages/personal/myFav.vue'
import MyExpertChatOrders from '../pages/personal/MyExpertChatOrders'
import myApplyToCash from '../pages/personal/myApplyToCash.vue'
import myApplyWithdrawal from '../pages/personal/myApplyWithdrawal.vue'
import bindBankCard from '../pages/personal/bindBankCard.vue'
import uconfigJoin from '../pages/personal/uconfig/join.vue'
import expertJoin from '@/pages/join/expertJoin'
import myProfitMoney from '../pages/personal/myProfitMoney'
import helpOrders from '../pages/help/orders'
import funeng from '../pages/funeng/index.vue'
import session from '@/pages/personal/session'
import distribution from '@/pages/personal/distribution'
import chatItem from '@/pages/personal/session/chatItem'
import chatitemExpert from '@/pages/personal/session/chatitemExpert'
import remarkChatExpert from '@/pages/personal/session/remarkChatExpert'
import listcompany from '@/pages/home/listcompany'
import content from '@/pages/help/content'
import offline from '@/pages/personal/offline'
import preview from '@/pages/detailPages/preview'
import merchant from '@/pages/merchant/orderIndex'
import merchantOrders from '@/pages/merchant/myOrders'
import OrdersExpressEdit from '@/pages/merchant/OrdersExpressEdit'
import companyInformation from '@/pages/merchant/company/list'

Vue.use(vueRouter)

export const routeslist = [
    {
        path: '/',
        redirect: '/homePage'
    },
    {
        path:"/homePage",
        component: homePage,
        meta: {
            title: '首页',
            show: true
        }
    },
    {
        path:'/login',
        component: login,
        meta:{
            title: '登陆',
            show: false
        }
    },
    {
        path:'/forgetPassword',
        component: forgetPassword,
        meta:{
            title: '忘记密码',
            
        }
    },
    {
        path:'/register',
        component: register,
        meta:{
            title: '注册'
        }
    },
    {
        path: '/article',
        name: 'article',
        component: article,
        meta: {
            title: '列表',
            show: true
        }
    },
    {
        path: '/acticleList',
        name: 'acticleList',
        component: acticleList,
        meta: {
            title: '列表',
            show: true
        }
    },
    {
        path: '/channelPolicy',
        name: 'channelPolicy',
        component: channelPolicy,
        meta:{
            title: '解读列表',
            show: true
        }
    },
    {
        path: '/detailPages',
        name: '',
        component: detailPages,
        meta: {
            title: '详情页',
            show: true
        }
    },
    {
        path: '/expert',
        name: 'expert',
        component: expert,
        meta: {
            title: '在线专家',
            show: true
        }
    },
    {
        path: '/expertJoin',
        name: 'expertJoin',
        component: expertJoin,
        meta: {
            title: '专家入驻',
            show: true
        }
    },
    {
        path: '/inquiry',
        name: 'inquiry',
        component: inquiry,
        meta: {
            title: '询价',
            show: true
        }
    },
    {
        path: '/myInquiry',
        name: 'myInquiry',
        component: myInquiry,
        meta: {
            title: '我的询价',
            show: true
        }
    },
    {
        path: '/MyInquiryInfo',
        name: 'MyInquiryInfo',
        component: MyInquiryInfo,
        meta: {
            title: '询价详情',
            show: true
        }
    },
    {
        path: '/MyInquiryCompany',
        name: 'MyInquiryCompany',
        component: MyInquiryCompany,
        meta: {
            title: '报价',
            show: true
        }
    },
    {
        path: '/companyDetail',
        name: 'companyDetail',
        component: companyDetail,
        meta: {
            title: '公司详情',
            show: true
        }
        
    },
    {
        path: '/detailInfo',
        name: 'detailInfo',
        component: detailInfo,
        meta: {
            title: '专家详情',
            show: true
        }
        
    },
    {
        path: '/videoDetail',
        name: 'videoDetail',
        component: videoDetail,
        meta: {
            title: '视频详情',
            show: true
        }
        
    },
    {
        path: '/school',
        name: 'school',
        component: school,
        meta: {
            title: '百家大讲堂',
            show: true
        }
    },
    {
        path: '/managementInfo',
        name: 'managementInfo',
        component: managementInfo,
        meta: {
            title: '企业管理体系详情',
            show: true
        }
    },
    {
        path: '/video',
        name: 'video',
        component: video,
        meta: {
            title: '视频',
            show: true
        }
    },
    {
        path: '/enable',
        name: 'enable',
        component: enable,
        meta: {
            title: '商品列表',
            show: true
        }
    },
    {
        path: '/enableInfo',
        name: 'enableInfo',
        component: enableInfo,
        meta: {
            title: '商品详情',
            show: true
        }
    },
    {
        path: '/join',
        name: 'join',
        component: join,
        meta: {
            title: '供应商入驻',
            show: true
        }
    },
    {
        path: '/joinList',
        name: 'joinList',
        component: joinList,
        meta: {
            title: '供应商入驻',
            show: true
        }
    },
    {
        path: '/train',
        name: 'train',
        component: train,
        meta: {
            title: '安全培训',
            show: true
        }
    },
    {
        path: '/trainInfo',
        name: 'trainInfo',
        component: trainInfo,
        meta: {
            title: '安全培训详情',
            show: true
        }
    },
    {
        path: '/recommend',
        name: 'recommend',
        component: recommend,
        meta: {
            title: '推荐',
            show: true
        }
    },
    {
        path: '/application',
        name: 'application',
        component: application,
        meta: {
            title: '安全培训报名',
            show: true
        }
    },
    {
        path: '/search',
        name: 'search',
        component: search,
        meta: {
            title: '搜索',
            show: true
        }
    },
    {
        path: '/courseware',
        name: 'courseware',
        component: courseware,
        meta: {
            title: '课件详情',
            show: true
        }
    },
    {
        path: '/listlive',
        name: 'listlive',
        component: listlive,
        meta: {
            title: '直播详情',
            show: true
        }
    },
    {
        path: '/personal',
        name: 'personal',
        component: personal,
        meta: {
            title: '个人中心',
            show: true
        }
    },
    {
        path: '/mySign',
        name: 'mySign',
        component: mySign,
        meta: {
            title: '签到',
            show: true
        }
    },
    {
        path: '/cart',
        name: 'cart',
        component: cart,
        meta: {
            title: '购物车',
            show: true
        }
    },
    {
        path: '/integral',
        name: 'integral',
        component: integral,
        meta: {
            title: '我的积分',
            show: true
        }
    },
    {
        path: '/teams',
        name: 'teams',
        component: teams,
        meta: {
            title: '我的团队',
            show: true
        }
    },
    {
        path: '/products',
        name: 'products',
        component: products,
        meta: {
            title: '商城',
            show: true
        }
    },
    {
        path: '/myOrders',
        name: 'myOrders',
        component: myOrders,
        meta: {
            title: '我的订单',
            show: true
        }
    },
    {
        path: '/infoSelf',
        name: 'infoSelf',
        component: infoSelf,
        meta: {
            title: '订单详情',
            show: true
        }
    },
    {
        path: '/applyAfterSales',
        name: 'applyAfterSales',
        component: applyAfterSales,
        meta: {
            title: '售后服务',
            show: true
        }
    },
    {
        path: '/remark',
        name: 'remark',
        component: remark,
        meta: {
            title: '评价',
            show: true
        }
    },
    {
        path: '/checkoutQuick',
        name: 'checkoutQuick',
        component: checkoutQuick,
        meta: {
            title: '购物车结算',
            show: true
        }
    },
    {
        path: '/myUserMoney',
        name: 'myUserMoney',
        component: myUserMoney,
        meta: {
            title: '财务明细',
            show: true
        }
    },
    {
        path: '/MyBooking',
        name: 'MyBooking',
        component: MyBooking,
        meta: {
            title: '我的报名',
            show: true
        }
    },
    {
        path: '/MyBookingInfo',
        name: 'MyBookingInfo',
        component: MyBookingInfo,
        meta: {
            title: '我的报名详情',
            show: true
        }
    },
    {
        path: '/uconfig',
        name: 'uconfig',
        component: uconfig,
        meta: {
            title: '设置',
            show: true
        }
    },
    {
        path: '/addressInfo',
        name: 'addressInfo',
        component: addressInfo,
        meta: {
            title: '地址信息',
            show: true
        }
    },

    {
        path: '/uconfigAddressInfo',
        name: 'uconfigAddressInfo',
        component: uconfigAddressInfo,
        meta: {
            title: '收货地址信息',
            show: true
        }
    },
    {
        path: '/uconfigInvoice',
        name: 'uconfigInvoice',
        component: uconfigInvoice,
        meta: {
            title: '发票地址信息',
            show: true
        }
    },
    {
        path: '/uconfigAdd',
        name: 'uconfigAdd',
        component: uconfigAdd,
        meta: {
            title: '新增收货地址',
            show: true
        }
    },
    {
        path: '/invoiceAddAddress',
        name: 'invoiceAddAddress',
        component: invoiceAddAddress,
        meta: {
            title: '新增发票地址',
            show: true
        }
    },
    {
        path: '/addressAddInvoice',
        name: 'addressAddInvoice',
        component: addressAddInvoice,
        meta: {
            title: '发票地址',
            show: true
        }
    },
    {
        path: '/addAddress',
        name: 'addAddress',
        component: addAddress,
        meta: {
            title: '收货地址',
            show: true
        }
    },
    {
        path: '/addressInvoice',
        name: 'addressInvoice',
        component: addressInvoice,
        meta: {
            title: '发票地址',
            show: true
        }
    },
    {
        path: '/myFav',
        name: 'myFav',
        component: myFav,
        meta: {
            title: '我的收藏',
            show: true
        }
    },
    {
        path: '/MyExpertChatOrders',
        name: 'MyExpertChatOrders',
        component: MyExpertChatOrders,
        meta: {
            title: '专家订单',
            show: true
        }
    },
    {
        path: '/myApplyToCash',
        name: 'myApplyToCash',
        component: myApplyToCash,
        meta: {
            title: '我的提现',
            show: true
        }
    },
    {
        path: '/myApplyWithdrawal',
        name: 'myApplyWithdrawal',
        component: myApplyWithdrawal,
        meta: {
            title: '申请提现',
            show: true
        }
    },
    {
        path: '/bindBankCard',
        name: 'bindBankCard',
        component: bindBankCard,
        meta: {
            title: '绑定银行卡',
            show: true
        }
    },
    {
        path: '/uconfigJoin',
        name: 'uconfigJoin',
        component: uconfigJoin,
        meta: {
            title: '企业用户入驻',
            show: true
        }
    },
    {
        path: '/myProfitMoney',
        name: 'myProfitMoney',
        component: myProfitMoney,
        meta: {
            title: '收益明细',
            show: true
        }
    },
    {
        path: '/help/orders',
        name: 'help/orders',
        component: helpOrders,
        meta: {
            title: '帮助中心',
            show: true
        }
    },
    {
        path: '/funeng',
        name: 'funeng',
        component: funeng,
        meta: {
            title: '赋能',
            show: true
        }
    },
    {
        path: '/session',
        name: 'session',
        component: session,
        meta: {
            title: '咨询',
            show: true
        }
    },
    {
        path: '/session/chatItem',
        name: 'session/chatItem',
        component: chatItem,
        meta: {
            title: '我的咨询',
            show: true
        }
    },
    {
        path: '/session/chatitemExpert',
        name: 'session/chatitemExpert',
        component: chatitemExpert,
        meta: {
            title: '专家咨询',
            show: true
        }
    },
    {
        path: '/session/remarkChatExpert',
        name: 'session/remarkChatExpert',
        component: remarkChatExpert,
        meta: {
            title: '咨询评价',
            show: true
        }
    },
    {
        path: '/distribution',
        name: 'distribution',
        component: distribution,
        meta: {
            title: '分销人员',
            show: true
        }
    },
    {
        path: '/listcompany',
        name: 'listcompany',
        component: listcompany,
        meta: {
            title: '入驻企业',
            show: true
        }
    },
    {
        path: '/help/content',
        name: 'help/content',
        component: content,
        meta: {
            title: '内容中心',
            show: true
        }
    },
    {
        path: '/offline',
        name: 'offline',
        component: offline,
        meta: {
            title: '订单提交',
            show: true
        }
    },
    {
        path: '/preview',
        name: 'preview',
        component: preview,
        meta: {
            title: 'pdf预览',
            show: true
        }
    },
    {
        path: '/merchant',
        name: 'merchant',
        component: merchant,
        meta: {
            title: '商家订单',
            show: true
        }
    },
    {
        path: '/merchantOrders',
        name: 'merchantOrders',
        component: merchantOrders,
        meta: {
            title: '商家订单列表',
            show: true
        }
    },
    {
        path: '/OrdersExpressEdit',
        name: 'OrdersExpressEdit',
        component: OrdersExpressEdit,
        meta: {
            title: '发货',
            show: true
        }
    },
    {
        path: '/companyInformation',
        name: 'companyInformation',
        component: companyInformation,
        meta: {
            title: '公司资料',
            show: true
        }
    }

]
const router = new vueRouter({
    routes: routeslist,
    mode: 'history'
})
router.afterEach((to) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
})

const originalPush = vueRouter.prototype.push
vueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router